
import { Component, Vue, Prop } from 'vue-property-decorator';
import { apolloClientNew } from '@/services/graphql';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Component
export default class SubscriptionBoundary extends Vue {
  @Prop({ type: String, required: true }) query!: string;
  @Prop({ type: Object, required: true }) variables!: any;
  @Prop({ type: Function, required: true }) nextFn!: (data: any) => any;

  protected observer = apolloClientNew.subscribe({
    query: gql(this.query),
    variables: this.variables
  });

  mounted() {
    this.observer.subscribe({
      next: this.nextFn
    });
  }

  render(h: Vue) {
    return this.$scopedSlots.default!({
      observable: this.observer
    });
  }
}
